<template>
  <v-form v-model="validForm">
    <v-card>
      <v-card-title>{{ t('views.dashboard.exportDialog.title') }}</v-card-title>
      <v-card-text>
        {{ t('views.dashboard.exportDialog.text') }}
        <v-text-field v-model="email" :label="t('domain.fields.email')" :rules="rules.email"></v-text-field>
        <v-text-field v-model="fileName" :label="t('views.dashboard.exportDialog.fileName')"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="!validForm" @click="send">{{ t('common.actions.send').toUpperCase() }}</v-btn>
        <v-btn color="error" @click="close">{{ t('common.actions.cancel').toUpperCase() }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import { computed, ref } from 'vue'

import { storeToRefs } from 'pinia'

import { useI18n } from 'vue-i18n'

import { isRequired, isValidEmail, validate } from '@tsyl/radon'
import { useNotifications } from '@tsyl/zapan2'

import { exportIncidents } from '@/services/api/incidents.ts'
import FiltersStore from '@/stores/FiltersStore.ts'
import { adaptFilter } from '@/utils/filters.ts'

const props = defineProps({
  visibleHeaders: {
    type: Array as PropType<string[]>,
    required: true
  }
})

const emits = defineEmits<{
  (event: 'closeDialog'): void
}>()

const validForm = ref(false)
const rules = computed(() => {
  return {
    email: validate('Email', isRequired(), isValidEmail()),
    fileName: validate('File Name', isRequired())
  }
})

const { filters, searchText } = storeToRefs(FiltersStore())
const { t } = useI18n()
const { addNotification } = useNotifications()
const email = ref('')
const fileName = ref('weatherIncidentList')

async function send() {
  const body = {
    columnsToShow: props.visibleHeaders,
    email: email.value,
    fileName: fileName.value,
    filters: filters.value.map(adaptFilter).filter((filter) => filter),
    search: searchText.value
  }

  try {
    await exportIncidents(body)
    addNotification({
      type: 'success',
      title: t('messages.success.exportRequested'),
      time: 10000
    })
  } catch (e) {
    console.error('Export incidents', e)
    addNotification({
      type: 'error',
      title: t('messages.error.exportRequest'),
      time: 10000
    })
  }
  close()
}

function close() {
  emits('closeDialog')
}
</script>

<style scoped lang="scss"></style>
